import { useEffect, useRef } from 'react';

// A successful async action may unmount its owner mid-await (e.g. an
// optimistic cache patch re-rendering the row), so post-await setState must
// be guarded with this instead of running unconditionally.
export const useIsMountedRef = () => {
  const isMountedRef = useRef(true);
  useEffect(
    () => () => {
      isMountedRef.current = false;
    },
    [],
  );
  return isMountedRef;
};
